import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

export default function DelayedRedirect({ delay, ...redirectProps }) {
  const [redirect, setRedirect] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setRedirect(true);
    }, delay || 0);

    return () => {
      clearTimeout(timer);
    };
  }, [delay]);

  return redirect ? <Navigate {...redirectProps} /> : null;
}
